<script lang="ts">
  import icons, { isFilled, type Icon } from '$lib/icons';

  export let icon: Icon;
  export let color = '#1d1d1b';
  export let size = 24;
  export let viewBox = 24;
  export let transition: boolean | string = false;
  export let hoverColor: string | null = null;
  export let casing: string | null = null;
  export let cursor = 'unset';
  export let backgroundColor = 'transparent';
  export let radius = 'unset';

  casing = casing === null ? `${size}px` : casing;
  hoverColor = hoverColor === null ? color : hoverColor;
  $: svg = icons[icon];
</script>

<span
  style={`
    --casing: ${casing};
    --cursor: ${cursor};
    --backgroundColor: ${backgroundColor};
    --radius: ${radius};
  `}
  class:filled={isFilled(icon)}
  on:click
  on:keypress
>
  <svg
    viewBox={`0 0 ${viewBox} ${viewBox}`}
    width={`${size}px`}
    height={`${size}px`}
    style="--color: {color}; --transition: {transition === false
      ? 'none'
      : transition === true
      ? '.2s ease all'
      : transition}; --color-hover: {hoverColor}"
    preserveAspectRatio="xMidYMid meet">{@html svg}</svg
  >
</span>

<style lang="scss">
  span {
    width: var(--casing);
    height: var(--casing);
    cursor: var(--cursor);
    display: grid;
    place-content: center;
    background-color: var(--backgroundColor);
    border-radius: var(--radius);
    svg {
      transition: var(--transition);
      :global(*) {
        stroke: var(--color);
        fill: transparent;
        transition: inherit;
      }
    }
    &:hover {
      svg {
        :global(*) {
          stroke: var(--color-hover);
        }
      }
    }
    &.filled {
      svg {
        :global(*) {
          stroke: none;
          fill: var(--color);
        }
      }
      &:hover {
        svg {
          :global(*) {
            stroke: none;
            fill: var(--color-hover);
          }
        }
      }
    }
  }
</style>
